import React, { useEffect, useState } from 'react';
import { arrayOf, object, bool } from 'prop-types';
import clsx from 'clsx';
import useStore from 'state/state';
import Thumb from './Thumb/Thumb';

import styles from './Media.module.scss';

const Media = ({ data, animateOut }) => {
  const [parsedData, setParsedData] = useState(null);
  const setIsGalleryOpen = useStore((state) => state.setIsGalleryOpen);
  const setClickedGalleryImage = useStore(
    (state) => state.setClickedGalleryImage
  );

  const onThumbClick = (key) => {
    setClickedGalleryImage(key);
    setIsGalleryOpen(true);
  };

  useEffect(() => {
    // console.log(data);
    const parsedDataArr = [];
    data.forEach((entry, key) => {
      const obj = {
        index: key,
        key: `${key}-thumb`,
        imageUrl: '',
        type: '',
        videoCoverImage: '',
        youtubeVideoId: '',
      };

      obj.type = entry.type;

      if (entry.type === 'video') {
        if (entry.videoCoverImageUrl) {
          obj.videoCoverImage = entry.videoCoverImageUrl;
        }
        obj.youtubeVideoId = entry.youtubeVideoId;
      } else {
        obj.imageUrl = `${entry.imageUrl}?width=1024&height=768`;
      }

      parsedDataArr.push(obj);
    });

    setParsedData(parsedDataArr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={clsx(styles.wrapper, { [styles.animateOut]: animateOut })}>
      {parsedData && (
        <>
          {parsedData.map(
            ({
              index,
              key,
              type,
              imageUrl,
              videoCoverImage,
              youtubeVideoId,
            }) => (
              <Thumb
                key={key}
                onClick={() => onThumbClick(index)}
                type={type}
                imageUrl={imageUrl}
                videoCoverImage={videoCoverImage}
                youtubeVideoId={youtubeVideoId}
              />
            )
          )}
        </>
      )}
    </div>
  );
};

Media.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: arrayOf(object).isRequired,
  animateOut: bool.isRequired,
};

export default Media;
